module.exports = __webpack_public_path__ + "4be0179d8693479f35ad5d10c74fb8a5.png";